export const mapTicketPriceToTicketDetails = (ticketPrice) => {
    return {
        ticketTypeId: ticketPrice.ticketTypeId,
        price: ticketPrice.price,
        bookingFee: ticketPrice.bookingFee
    };
};
export const mapMemberRewardTicketPriceToTicketDetails = (ticketPrice) => {
    return Object.assign(Object.assign({}, mapTicketPriceToTicketDetails(ticketPrice)), { rewardId: ticketPrice.rewardId });
};
export const mapVoucherTicketPriceToTicketDetails = (ticketPrice, voucherId) => {
    return Object.assign(Object.assign({}, mapTicketPriceToTicketDetails(ticketPrice)), { voucherId });
};
export const mapTicketRedemptionCardPriceToTicketDetails = (ticketPrice, ticketRedemptionCardId) => {
    return Object.assign(Object.assign({}, mapTicketPriceToTicketDetails(ticketPrice)), { ticketRedemptionCardId });
};
